/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class user extends IceEntity {
  trans_account: string = "";
  account_type: number = 0;
  login_user_name: string = "";
  email: string = "";
  first_name: string = "";
  last_name: string = "";
  middle: string = "";
  prefix: string = "";
  suffix: string = "";
  phone_num: string = "";
  dob: any = NaN;
  provider_trans_account: string = "";
  offline_record_status: number = 0; // Newly added
  owner: string = "";
  supervisor: string = "";
  nameofnetwork: string = "";
  message_status: IceTypes.trans_status.isNone;
  external_data_key: string = "";
  signature_code: string = "";
  country_id: string = "";

  getdisplayname(): string {
    var disply = this.prefix;
    if (disply.length > 0)
      disply += " ";

    disply += this.first_name;

    if (this.middle != null && this.middle.length > 0)
      disply += ", " + this.middle;

    if (disply.length > 0)
      disply += " " + this.last_name;

    if (this.suffix.length > 0)
      disply += ", " + this.suffix;

    return disply;
  }

  gettablename(): string {
    return "USER";
  }
}
